import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Layout from "../src/components/common/Layout";

import Login from "./Pages/Login/Login";
import { LoaderProvider } from "./Context/ContextFunctions";
import UserRoleList from "./Pages/Master/UserRole/UserRoleList";

const App = () => {
  // const navigate = useNavigate();
  // const location = useLocation();
  // useEffect(() => {
  //   if (location?.pathName === "/logout") {
  //     localStorage.clear();
  //     navigate("/login");
  //     window.location.reload();
  //   }
  // }, [navigate]);

  const Dashboard = lazy(() => import("./Pages/Dashboard/Dashboard"));
  const Employee = lazy(() => import("./Pages/Master/Employee/EmployeeList"));
  const Lead = lazy(() => import("./Pages/Lead/LeadList"));
  const Source = lazy(() => import("./Pages/Master/Source/SourceList"));
  const EnquiryReceived = lazy(() =>
    import("./Pages/EnquiryRecevied/EnquiryReceivedList")
  );
  const ESTBoq = lazy(() => import("./Pages/ESTBOQ/EstBoqList"));
  const SalesLog = lazy(() => import("./Pages/SalesLog/SalesLogList"));
  const Invoice = lazy(() => import("./Pages/Invoice/InvoiceList"));
  const AccountLog = lazy(() => import("./Pages/AccountLog/AccountLogList"));
  const Followup = lazy(() => import("./Pages/Follow-up/FollowupList"));
  const Quotation = lazy(() => import("./Pages/Quotation/QuotationList"));
  const AssignSitePage = lazy(() =>
    import("./Pages/Master/Employee/AssignSitePage")
  );
  const Country = lazy(() =>
    import("./Pages/Master/AddressMaster/Country/CountryList")
  );

  const StateList = lazy(() =>
    import("./Pages/Master/AddressMaster/State/StateList")
  );
  const DistrictList = lazy(() =>
    import("./Pages/Master/AddressMaster/District/DistrictList")
  );
  const TalukaList = lazy(() =>
    import("./Pages/Master/AddressMaster/Taluka/TalukaList")
  );
  const MIDCList = lazy(() =>
    import("./Pages/Master/AddressMaster/MIDC/MIDCList")
  );
  const UnprocessedEnquiry = lazy(() =>
    import("./Pages/Reports/UnprocessedEnquiry/UnprocessedEnquiry")
  );

  const Profile = lazy(() => import("./Pages/Profile/Profile"));
  const DetailedLog = lazy(() =>
    import("./Pages/DetailedLogs/DetailedLeadLogs")
  );
  const PreViewQuotation = lazy(() =>
    import("./Pages/Quotation/PreViewQuotation")
  );
  const AddUpdateQuotation = lazy(() =>
    import("./Pages/Quotation/AddUpdateQuotation")
  );
  const Company = lazy(() => import("./Pages/Master/Company/CompanyList"));
  const Designation = lazy(() =>
    import("./Pages/Master/Designation/DesignationList")
  );
  const Unit = lazy(() => import("./Pages/Master/Unit/UnitsList"));
  const Site = lazy(() => import("./Pages/Master/Sites/SiteList"));
  const UnProcessedLead = lazy(() =>
    import("./Pages/Reports/UnProcessedLead/UnProcessedLeadList")
  );
  const FieldVisitReport = lazy(() =>
    import("./Pages/Reports/FieldAttendanceReport/FieldAttendanceReportList")
  );
  const Product = lazy(() => import("./Pages/Product/ProductList"));
  const TermsAndCondition = lazy(() =>
    import("./Pages/Master/TermsAndCondition/TAndCList")
  );
  const DVR = lazy(() => import("./Pages/Reports/DVR/DvrList"));
  const Customer = lazy(() => import("./Pages/Master/AddCustomer/AddCustomer"));
  const Logout = lazy(() => import("./Pages/Login/Login"));
  const AccountReport = lazy(() =>
    import("./Pages/Reports/AccountReport/AccountReport")
  );
  const PreViewPO = lazy(() => import("./components/common/POPreviewPage"));
  const UnProcessedQuotationReport = lazy(() =>
    import(
      "./Pages/Reports/UnProcessedQuotationReport/UnProcessedQuotationReport"
    )
  );
  const TaskManagementList = lazy(() =>
    import(
      "./Pages/TaskManagement/TaskManagementList"
    )
  );
  const HelpRequestList = lazy(() =>
    import(
      "./Pages/TaskManagement/HelpRequestList"
    )
  );
  const NotesAndAttachments = lazy(() =>
    import(
      "./Pages/TaskManagement/NotesAndAttachments"
    )
  );
  const UnprocessedOrder = lazy(() => import("./Pages/Reports/UnprocessedOrder/UnprocessedOrder"));
  return (
    <Router>
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <LoaderProvider>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/accountLog" element={<AccountLog />} />
              <Route path="/company" element={<Company />} />
              <Route path="/source" element={<Source />} />
              <Route path="/user-role" element={<UserRoleList />} />
              <Route path="/Customer" element={<Customer />} />
              <Route path="/product" element={<Product />} />
              <Route path="/task-management" element={<TaskManagementList />} />
              <Route path="/help-requested-list" element={<HelpRequestList />} />
              <Route path="/notes-attachments-list" element={<NotesAndAttachments />} />
              <Route path="/lead" element={<Lead />} />
              <Route path="/salesLog" element={<SalesLog />} />
              <Route path="/detailedLog" element={<DetailedLog />} />
              <Route path="/estBoq" element={<ESTBoq />} />
              <Route path="/invoice" element={<Invoice />} />
              <Route path="/login" element={<Login />} />
              <Route path="/enquiry-received" element={<EnquiryReceived />} />
              <Route path="/followup" element={<Followup />} />
              <Route path="/assignSitePage" element={<AssignSitePage />} />
              <Route path="/quotation" element={<Quotation />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/viewQuotation" element={<PreViewQuotation />} />
              <Route path="/employee" element={<Employee />} />
              <Route path="/designation" element={<Designation />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/unit" element={<Unit />} />
              <Route path="/site" element={<Site />} />
              <Route path="/state" element={<StateList />} />
              <Route path="/district" element={<DistrictList />} />
              <Route path="/taluka" element={<TalukaList />} />
              <Route path="/midc" element={<MIDCList />} />
              <Route path="/country" element={<Country />} />
              <Route path="/dvr" element={<DVR />} />
              <Route path="/previewPO" element={<PreViewPO />} />
              <Route path="/unprocessed-order" element={<UnprocessedOrder />} />
              <Route
                path="/unProcessedEnquiry"
                element={<UnprocessedEnquiry />}
              />
              <Route
                path="/termsAndCondition"
                element={<TermsAndCondition />}
              />
              <Route
                path="/fieldAttendanceReport"
                element={<FieldVisitReport />}
              />
              <Route
                path="/addUpdateQuotation"
                element={<AddUpdateQuotation />}
              />
              <Route path="/unProcessedLead" element={<UnProcessedLead />} />
              <Route path="/account-report" element={<AccountReport />} />

              <Route
                path="/unProcessedQuotation"
                element={<UnProcessedQuotationReport />}
              />
            </Routes>
          </LoaderProvider>
        </Suspense>
      </Layout>
    </Router>
  );
};

export default App;
